import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mt-6">
          页面未找到
        </h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-600">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex mt-6 px-5 py-2.5 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}